// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__-DUd6","questions":"styles_questions__UF53o","footer":"styles_footer__161ZA"};